let variantSize
let variantProductId
let currentVariant = null
let variantColor
$(document).ready(function(){
    var url = new URL(window.location.href);
    var variantId = url.searchParams.get('variant');
    if (variantId !== null) {
        var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
        for(const variant of variantsInfo){
            if(variant.id == variantId){
                variantProductId = variant.product
                variantSize = variant.options[0]
                variantColor = variant.color
                const productId = variant.product
                mp_show_images(productId)
                mp_update_sizes()
                mp_select_variant()
                $('.labellll').each(function(){
                    if($(this).attr('secondproduct') == variantProductId){
                        $(this).addClass('round-border')
                    }
                })
                $('.pills-variant-labels').each(function(){
                    if($(this).attr('val').toUpperCase() == variantSize && !$(this).hasClass('disabled')){
                        $(this).addClass('round-border')
                    }
                    if($(this).attr('val').toUpperCase() == variantSize && $(this).hasClass('disabled')){
                        $('.product-form__submit').attr('disabled','disabled')
                        $('.add_to_cart_quantity').text('Agotado')
                    }
                })
                changeZoomSliderImages(variantColor)
            }
        }
    }
    else{
      console.log('No hay variante seleccionada')
      $('label[name="TALLA"]').each(function () {
        const $label = $(this);
        const $input = $label.prev('input');
      
        if (!$input.hasClass('disabled')) {
          console.log($label)
          setTimeout(() => {
            $label.trigger('click');
          }, 200);
          return false;
        }
      });
    }
    $('.input-variant').on('click',function(){
        if($(this).attr('name') == 'TALLA'){
            variantSize = $(this).attr('val')
            $('.pills-variant-labels').removeClass('round-border')
        }
        if($(this).attr('name') == 'COLOR'){
            variantProductId = $(this).attr('secondproduct')
            const productId = $(this).attr('secondproduct')
            mp_show_images(productId)
            $('.labellll').removeClass('round-border')
            changeZoomSliderImages($(this).attr('val'))
            setTimeout(() => {
            let sublistSwiper2 = document.querySelector('.js-media-sublist').swiper;
            sublistSwiper2.slideTo(5,0)
            sublistSwiper2.slideTo(0,0)
            console.log('Se actualizó')
            }, 200);
        }
        mp_update_sizes()
        $(this).addClass('round-border')
        mp_select_variant()
    })
})


function changeZoomSliderImages(color){
    console.log('bloquea las imagenes')
    $('.s3 [data-color]').each(function() {
        if ($(this).attr('data-color') != color) {
            $(this).css('display', 'none');
        } else {
            $(this).css('display', 'flex');
        }
    });
}

function mp_show_images(productId){
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-sublist [data-element]:not([data-element='" + productId + "'])"), (e) => {
        e.classList.add("non-swiper-slide"), e.classList.remove("swiper-slide"), e.removeAttribute("style");
    }),
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-sublist [data-element='" + productId + "']"), (e) => {
        e.classList.remove("non-swiper-slide"), e.classList.add("swiper-slide"), e.removeAttribute("style");
    }),
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-list [data-element]:not([data-element='" + productId + "'])"), (e) => {
        e.classList.add("non-swiper-slide"), e.classList.remove("swiper-slide"), e.removeAttribute("style");
    }),
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-list [data-element='" + productId + "']"), (e) => {
        e.classList.remove("non-swiper-slide"), e.classList.add("swiper-slide"), e.removeAttribute("style");
    });
}
function mp_select_variant(){
  if(variantSize == undefined){
    $('label[name="TALLA"]').click()
  }
    var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
    for(const variant of variantsInfo){
        if(variant.options.includes(variantSize) && variant.product == variantProductId){
            if(variant.available){
                currentVariant = variant.id
                variantColor = variant.color
              $('.outOfStock_Badge').addClass('d-none')
            }
          else{
              $('.outOfStock_Badge').removeClass('d-none')
          }
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.href);
            $('.product__sku').html('<span class="visually-hidden">SKU:</span>'+variant.sku+'</p>')
            var price = variant.price
           let hasDiscount = variant.has_discount
            console.log(variant)
            console.log('no compare ',variant.compare_at_price)
            let sizes = []
            for(const variant of variantsInfo){
                if(variant.product == variantProductId){
                    if(variant.available){
                        sizes.push(variant.options[0])
                    }
                }
            }
            if(variant.compare_at_price){
                console.log('compare ',variant.compare_at_price)
                $('.price-item.price-item--regular').text(variant.compare_at_price)
                $('.price-item.price-item--sale').text(variant.price)
                $('.price__sale').css('display','flex')
                $('.price__regular').css('display','none')
                $('.product .price').addClass('price--on-sale')
              if(hasDiscount){
                     const badge = `<?xml version="1.0" encoding="UTF-8"?><svg id="Capa_2" style="width:100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 544.1 281.1"><defs><style>.cls-1{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:4.1px;}.cls-1,.cls-2{fill:none;}.cls-3{filter:url(#drop-shadow-1);}.cls-4{filter:url(#drop-shadow-2);}.cls-2{stroke:#f00028;stroke-miterlimit:10;stroke-width:1.8px;}.cls-5{fill:#fff;}.cls-6{fill:#f00028;}.cls-7{opacity:1;}.cls-8{fill:#f8fffc;}</style><filter id="drop-shadow-1" x="320.4" y="160.4" width="183" height="90" filterUnits="userSpaceOnUse"><feOffset dx="4.1" dy="4.1"/><feGaussianBlur result="blur" stdDeviation="2.9"/><feFlood flood-color="#000" flood-opacity=".5"/><feComposite in2="blur" operator="in"/><feComposite in="SourceGraphic"/></filter><filter id="drop-shadow-2" x="323.4" y="103.4" width="158" height="89" filterUnits="userSpaceOnUse"><feOffset dx="4.1" dy="4.1"/><feGaussianBlur result="blur-2" stdDeviation="2.9"/><feFlood flood-color="#000" flood-opacity=".5"/><feComposite in2="blur-2" operator="in"/><feComposite in="SourceGraphic"/></filter></defs><g id="Capa_1-2"><rect y="140.2" width="331.4" height="115.3"/><path class="cls-6" d="M530.3,126.2s-1.2-12.1,1.7-14.7c2.8-2.6,2.1-12.3,2-12.7-.2-.5-15.4,19.7-28.2,19.1-12.7-.6-9.4-12-4-14.7,0,0,2.8-3.5,15.7-6.5,12.8-3,19.1-12.1,19.8-19.6.7-7.5-.7-22.9-7-31.2-6.3-8.3-13.7-29.3-12.9-35.9.8-6.6,0-8.3-.8-7.8-.9.5-5.6,3.9-5.1,11.2.5,7.4.6,21.8.7,25.6.3,13.9.5,16.9-.9,19.8-2,4.4-4.9,6.9-8.9,10.3-5.4,4.6-12.5,10.7-19,8.5-3.3-1.1-5.1-3.8-6.4-5.8-4.6-6.9-3.1-14.7-2.7-16.5,1.7-8.3,7.3-13.1,9-14.5,0,0,2.5-3.2-4.1-.7-6.6,2.5-18.6,10.8-20.2,21.7-1.7,10.9-13,25.9-13,25.9,0,0-2.4,5.1-10.6,3.1-8.2-2-6.4-25.8,2.5-31,0,0-1-2.1-10.6.9-9.6,3.1-116.6,19-116.6,19,0,0-13-.3-27,16-15.2,17.6-56.1,65.2-56.1,65.2,0,0-3.5,2.4-2.7,14.9.8,12.5,6.5,43.5,9.5,47.4l78.8,48.9s2.6,7.1,28.2,6.6l165.1-25.4s32-4.3,36.1-42.9l-12.1-84.2ZM283.6,204c-10,0-18-8.1-18-18s8.1-18,18-18,18,8.1,18,18-8.1,18-18,18Z"/><g class="cls-3"><path class="cls-8" d="M350.6,198.3c-1-.9-2.3-1.5-3.8-1.8-1.5-.3-2.9-.3-4.2,0-.8.1-1.5.3-2.3.6-.8.3-1.5.7-2.1,1.2-.6.5-1.1,1.1-1.5,1.8-.3.7-.4,1.5-.3,2.4.2,1.4.9,2.4,2.1,3,1.2.6,2.6,1,4.3,1.3,1.7.3,3.5.5,5.5.7,1.9.2,3.8.7,5.6,1.4,1.8.7,3.3,1.8,4.6,3.2,1.3,1.5,2.2,3.6,2.7,6.3.4,2.6.3,5-.3,7.1-.7,2.1-1.7,3.9-3.1,5.5-1.4,1.6-3.2,2.8-5.3,3.8-2.1,1-4.3,1.7-6.8,2.1-3,.5-5.9.5-8.7,0-2.8-.5-5.4-1.6-8-3.3l6-9.3c1.3,1.2,2.8,2.1,4.5,2.6,1.7.5,3.5.6,5.2.3.8-.1,1.7-.4,2.5-.7.8-.3,1.6-.8,2.2-1.3.6-.5,1.1-1.1,1.4-1.8.3-.7.4-1.4.3-2.3-.2-1.4-1-2.4-2.2-3.1-1.2-.6-2.7-1.1-4.4-1.4-1.7-.3-3.6-.6-5.6-.9-2-.3-3.9-.7-5.7-1.4-1.8-.7-3.4-1.8-4.7-3.2-1.3-1.4-2.2-3.4-2.7-6-.4-2.5-.3-4.8.4-6.9.7-2.1,1.7-3.9,3.2-5.4,1.4-1.6,3.2-2.8,5.3-3.8,2.1-1,4.2-1.7,6.5-2.1,2.6-.4,5.3-.5,7.9-.1,2.6.3,5,1.2,7.3,2.7l-5.8,8.9Z"/><path class="cls-8" d="M379,181.9l8.5-1.4,28.1,43.5-11.6,1.9-5.7-9.3-18.2,3-2.3,10.6-11.4,1.9,12.6-50.2ZM385.2,194.9l-3.3,15.5,11.5-1.9-8.1-13.6Z"/><path class="cls-8" d="M413,176.3l10.3-1.7,6.1,37.3,19.1-3.1,1.6,9.5-29.5,4.8-7.7-46.9Z"/><path class="cls-8" d="M448.5,170.5l31.8-5.2,1.6,9.5-21.5,3.5,1.4,8.7,20.3-3.3,1.6,9.5-20.3,3.3,1.6,9.6,22.7-3.7,1.6,9.5-33,5.4-7.7-46.9Z"/></g><g class="cls-4"><path class="cls-8" d="M328.4,131.7l10.3-1.7,2.9,17.5,20.1-3.3-2.9-17.5,10.3-1.7,7.7,46.9-10.3,1.7-3.3-20.3-20.1,3.3,3.3,20.3-10.3,1.7-7.7-46.9Z"/><path class="cls-8" d="M380.2,136.8c.8-3.3,2.1-6.1,4-8.6,1.9-2.5,4.3-4.6,7.2-6.2,2.9-1.7,6.2-2.8,9.8-3.4,3.7-.6,7.1-.6,10.4,0,3.3.6,6.2,1.8,8.8,3.6,2.6,1.8,4.8,4.1,6.5,6.9,1.8,2.8,2.9,6.1,3.6,9.9.6,3.8.5,7.3-.2,10.5-.8,3.3-2.1,6.1-4,8.6-1.9,2.5-4.3,4.6-7.2,6.2-2.9,1.7-6.2,2.8-9.8,3.4-3.7.6-7.1.6-10.4,0-3.3-.6-6.2-1.8-8.8-3.6-2.6-1.8-4.8-4.1-6.5-6.9-1.8-2.8-2.9-6.1-3.6-9.9-.6-3.7-.5-7.3.2-10.5ZM392.7,151.4c1,1.7,2.2,3.1,3.7,4.3,1.5,1.1,3.2,1.9,5.1,2.4,1.9.5,4,.5,6.2.1,2.2-.4,4.1-1.1,5.8-2.1,1.7-1,3-2.3,4.1-3.9,1.1-1.6,1.8-3.3,2.2-5.2.4-1.9.4-4,0-6.2-.4-2.2-1-4.1-2-5.9-1-1.7-2.2-3.2-3.7-4.3-1.5-1.1-3.2-1.9-5.1-2.4-1.9-.5-4-.5-6.2-.1-2.2.4-4.1,1.1-5.8,2.1-1.7,1-3,2.3-4.1,3.9-1.1,1.6-1.8,3.3-2.2,5.3-.4,2-.4,4,0,6.2.4,2.2,1,4.2,2,5.9Z"/><path class="cls-8" d="M444.3,122.1l-13.4,2.2-1.5-9.1,37.1-6.1,1.5,9.1-13.4,2.2,6.2,37.7-10.3,1.7-6.2-37.7Z"/></g><path class="cls-5" d="M351.6,256l-1.2.2-3.1-5.4h0s-.9,6.1-.9,6.1l-1.3.2-3.7-7.1,1.4-.2,2.7,5.5h0s1-6.1,1-6.1l1.3-.2,2.9,5.4h0s.7-6,.7-6l1.3-.2-1.2,7.9Z"/><path class="cls-5" d="M363.4,254l-1.2.2-3.1-5.4h0s-.9,6.1-.9,6.1l-1.3.2-3.7-7.1,1.4-.2,2.7,5.5h0s1-6.1,1-6.1l1.3-.2,2.9,5.4h0s.7-6,.7-6l1.3-.2-1.2,7.9Z"/><path class="cls-5" d="M375.3,252.1l-1.2.2-3.1-5.4h0s-.9,6.1-.9,6.1l-1.3.2-3.7-7.1,1.4-.2,2.7,5.5h0s1-6.1,1-6.1l1.3-.2,2.9,5.4h0s.7-6,.7-6l1.3-.2-1.2,7.9Z"/><path class="cls-5" d="M380.1,250.4c0,.5-.3,1-.8,1.1-.5,0-1-.3-1.1-.8,0-.5.3-1,.8-1.1.5,0,1,.3,1.1.8Z"/><path class="cls-5" d="M380.7,238.8l1.2-.2.9,5.6h0c.2-.7,1-1.4,2.2-1.6,2-.3,3,.8,3.3,2.6l.8,4.6-1.2.2-.7-4.5c-.2-1.2-.9-1.9-2-1.7-1.6.3-2.1,1.5-1.8,3.3l.6,3.6-1.2.2-2-12.1Z"/><path class="cls-5" d="M393.8,241.2c2.3-.4,4.3.9,4.6,3.3.4,2.3-1,4.2-3.3,4.6-2.3.4-4.3-.9-4.6-3.3-.4-2.3,1-4.2,3.3-4.6ZM394.9,247.9c1.6-.3,2.5-1.6,2.2-3.2-.3-1.6-1.5-2.6-3.1-2.3-1.6.3-2.5,1.6-2.2,3.2.3,1.6,1.5,2.6,3.1,2.3Z"/><path class="cls-5" d="M404,240.8l-2.2.4.6,3.7c.2,1,.3,1.7,1.4,1.5.4,0,.8-.2,1.1-.4l.2,1.1c-.4.3-.9.4-1.4.5-1.8.3-2.2-.6-2.5-2.2l-.7-4.1-1.6.3-.2-1.1,1.6-.3-.3-2.1,1.2-.2.3,2.1,2.2-.4.2,1.1Z"/><path class="cls-5" d="M406.5,244.9c.6.5,1.2.8,2.1.7.8-.1,1.6-.6,1.5-1.4-.1-.8-1-.9-1.8-.9-1.5,0-2.7-.2-3-1.7-.2-1.5,1-2.4,2.4-2.7,1.1-.2,2.1,0,2.8.9l-.9.9c-.4-.5-1-.8-1.7-.6-.7.1-1.4.6-1.3,1.3.1.6,1,.7,2.1.8,1.4,0,2.6.3,2.8,1.8.3,1.7-1.1,2.6-2.6,2.8-1.3.2-2.2,0-3.1-.9l.9-.9Z"/><path class="cls-5" d="M412.3,239.3c.6-.9,1.7-1.5,2.8-1.6,2.2-.4,3.3.5,3.7,2.6l.5,3.2c0,.4.2.9.3,1.3l-1.2.2c-.1-.3-.2-.8-.3-1.1h0c-.4.9-1.1,1.5-2.2,1.7-1.5.2-2.9-.3-3.1-1.8-.4-2.5,2.4-3.1,4.3-3.4h.5c0,0,0-.3,0-.3-.2-1.1-1-1.5-2.1-1.3-.8.1-1.6.5-2.1,1.2l-.9-.7ZM416.3,241.6c-1.6.3-2.5.9-2.4,1.9.2.9.9,1.2,1.9,1,1.4-.2,2-1.4,1.8-2.6v-.5c0,0-1.3.2-1.3.2Z"/><path class="cls-5" d="M419.8,232.4l1.2-.2,2,12.1-1.2.2-2-12.1Z"/><path class="cls-5" d="M432,241.4c-.7,1.3-1.7,1.9-3.1,2.1-2.3.4-4.1-1.1-4.4-3.3-.4-2.3,1-4.2,3.2-4.6,2.1-.3,3.8.9,4.2,3.3v.4c0,0-6,1-6,1,.3,1.3,1.5,2.2,2.8,2,1.1-.2,1.7-.7,2.2-1.5l1.1.6ZM430.4,238.5c-.3-1.3-1.2-2-2.6-1.7-1.4.2-2.1,1.2-2.1,2.5l4.7-.8Z"/><path class="cls-5" d="M436.3,241.2c0,.5-.3,1-.8,1.1-.5,0-1-.3-1.1-.8,0-.5.3-1,.8-1.1.5,0,1,.3,1.1.8Z"/><path class="cls-5" d="M443.3,235.1c-.6-.6-1.3-.7-2-.6-1.7.3-2.3,1.7-2.1,3.2.3,1.5,1.5,2.6,3,2.4.8-.1,1.4-.5,1.7-1.2l1.1.7c-.6.9-1.5,1.5-2.6,1.7-2.3.4-4.1-1-4.5-3.3-.4-2.3.9-4.2,3.2-4.6,1.1-.2,2.2,0,3.1.7l-.8,1Z"/><path class="cls-5" d="M448.9,232.1c2.3-.4,4.3.9,4.6,3.3.4,2.3-1,4.2-3.3,4.6-2.3.4-4.3-.9-4.6-3.3-.4-2.3,1-4.2,3.3-4.6ZM450,238.8c1.6-.3,2.5-1.6,2.2-3.2-.3-1.6-1.5-2.6-3.1-2.3-1.6.3-2.5,1.6-2.2,3.2.3,1.6,1.5,2.6,3.1,2.3Z"/><path class="cls-5" d="M455.1,233.1c-.1-.7-.3-1.3-.4-1.8l1.2-.2c0,.4.2.8.2,1.2h0c.2-.8,1-1.6,2.3-1.8,1.6-.3,2.3.6,2.6,1,.4-1,1-1.6,2.1-1.8,2.1-.4,3,.7,3.4,2.7l.7,4.5-1.2.2-.7-4.5c-.2-1-.7-2-2.2-1.7-1.1.2-1.8,1.2-1.6,2.5l.7,4.3-1.2.2-.7-4.2c-.3-1.6-.8-2.2-1.8-2-1.6.3-2.1,1.5-1.8,3.3l.6,3.6-1.2.2-.9-5.7Z"/><path class="cls-5" d="M471.5,235.4c0,.5-.3,1-.8,1.1-.5,0-1-.3-1.1-.8,0-.5.3-1,.8-1.1.5,0,1,.3,1.1.8Z"/><path class="cls-5" d="M473.2,230.1c-.1-.7-.3-1.3-.4-1.8l1.2-.2c0,.4.2.8.2,1.2h0c.2-.8,1-1.6,2.3-1.8,1.6-.3,2.3.6,2.6,1,.4-1,1-1.6,2.1-1.8,2.1-.4,3,.7,3.4,2.7l.7,4.5-1.2.2-.7-4.5c-.2-1-.7-2-2.2-1.7-1.1.2-1.8,1.2-1.6,2.5l.7,4.3-1.2.2-.7-4.2c-.3-1.6-.8-2.2-1.8-2-1.6.3-2.1,1.5-1.8,3.3l.6,3.6-1.2.2-.9-5.7Z"/><path class="cls-5" d="M489,229.2l-3.3-3,1.6-.3,2.4,2.4,1.4-3,1.5-.2-2,3.9,3.7,3.5-1.6.3-2.9-2.8-1.8,3.6-1.5.3,2.4-4.5Z"/><path class="cls-1" d="M530.3,126.2c-.4-5.9.5-10.3,1.5-13.2,0,0,3.7-11.6,2.2-14.2,0,0,0,0,0,0-.3-.2-15.5,19.7-28.1,19.1-12.7-.6-9.4-12-4-14.7,0,0,2.8-3.5,15.7-6.5,12.8-3,19.1-12.1,19.8-19.6,1-10.8-2-21-7-31.2-1.2-2.4-2.2-4.1-2.2-4.1-1.8-3.3-2.5-4.4-3.8-6.9-1.1-2.1-1.9-3.8-2.1-4.1-3.2-6.7-5.2-17.3-4.8-24,0-1,.3-4.5-.5-4.7-.1,0-.3,0-.3,0-2.7,1.4-4,4.6-4,4.6-1.3,3.4-1.2,6.4-1.2,6.6.8,15.1.7,25.6.7,25.6,0,11.2,0,16.9-.9,19.2-3.2,8.2-9.9,12.6-13.7,15.1-4.3,2.8-9.4,6.2-14.2,4.4-2.7-1-4.5-3.5-5.7-5.1-2.4-3.3-3.1-6.6-3.4-8.2-.2-.8-.8-4.5,0-9,1.6-8.3,7.5-13.4,9.6-15,0-.2,0-.6-.2-.8-.7-.9-3.3.2-4.5.6-9.6,3.9-14.5,9.8-14.5,9.8-1,1.1-4.6,5.5-6.2,11-.2.8-.6,2.3-1.4,4.8-.4,1.2-1.1,3.5-2.1,6.2-1.7,4.7-3,8-5.5,11.7-1.1,1.5-2.1,2.7-2.7,3.4-.4.6-1.1,1.3-2.1,2.1-2.3,1.7-6.3,3.4-9.4,1.9-2.1-1-3-3.1-3.6-4.7-3.4-8.2.2-18.3,4.8-24.7.5-.7,1-1.3,1.3-1.7-.6-.1-1.5-.3-2.7-.4-2.1-.1-3.7.2-4.4.3-4.2.8-8.5,1.5-12.7,2.5-3.7.8-27.4,4.8-106.9,17.1-.6.1-1.6.4-2.7.7-13.1,3.7-21.4,12.2-24.7,15.7-19.4,20.4-56.1,65.2-56.1,65.2,0,0-3.5,2.4-2.7,14.9.8,12.5,6.5,43.5,9.5,47.4l78.8,48.9c2.1,1.4,4.6,2.8,7.6,4,8.4,3.3,16,3.1,20.6,2.6l165.1-25.4c4.2-.9,14.1-3.5,22.7-12.2,12.1-12.1,12.9-27.2,13-30.8-3.9-28-7.8-56.1-11.8-84.1ZM283.6,204c-10,0-18-8.1-18-18s8.1-18,18-18,18,8.1,18,18-8.1,18-18,18Z"/><path class="cls-6" d="M533.1,8c0-.6,0-1.4,0-1.9h0c-.2.5-.3,1.1-.6,1.7l-.8,2.2h-.4l-.7-2.1c-.2-.6-.4-1.2-.5-1.7h0c0,.6,0,1.3,0,2v1.9h-.7l.3-4.5h.7l.8,2.2c.2.5.3,1,.4,1.5h0c.1-.4.3-.9.5-1.5l.8-2.2h.7l.3,4.5h-.6v-2Z"/><path class="cls-6" d="M534.7,5.5c.3,0,.7,0,1.1,0,.6,0,1,.1,1.3.4.2.2.4.5.4.8,0,.6-.4,1-.8,1.1h0c.3.1.5.5.7.9.1.6.3,1.1.3,1.2h-.6c0-.1-.2-.5-.3-1.1-.1-.6-.4-.8-.9-.9h-.5v1.9h-.6v-4.4ZM535.2,7.5h.6c.6,0,1-.3,1-.8s-.4-.8-1-.8c-.3,0-.5,0-.6,0v1.6Z"/><circle class="cls-2" cx="533.3" cy="8" r="6.3"/><g class="cls-7"><path class="cls-5" d="M28,199.3h26.5v10h-26.5v-10Z"/><path class="cls-5" d="M80.6,163.7v67.4h-12.5v-56.9h-14.3v-10.5h26.8Z"/><path class="cls-5" d="M138.2,210.4c0,11.8-8.6,21.7-26.7,21.7s-19.2-2.9-25.3-7.8l5.3-9.7c4.9,4,12.2,6.6,19.8,6.6s14.3-3.9,14.3-10.3-4.1-10.5-18.1-10.5h-16.3l3.5-36.7h39.6v10.5h-29l-1.4,15.6h6.5c19.9,0,27.9,8.7,27.9,20.6Z"/><path class="cls-5" d="M155.6,194.6c0-8.1,4.7-13.6,11.8-13.6s11.9,5.4,11.9,13.6-4.8,13.6-11.9,13.6-11.8-5.4-11.8-13.6ZM173.5,194.6c0-5.5-2.3-8.6-6.1-8.6s-6.1,3.2-6.1,8.6,2.4,8.6,6.1,8.6,6.1-3.1,6.1-8.6ZM197.1,181.5h6.9l-33.8,49.5h-6.9l33.8-49.5ZM188.1,218c0-8.1,4.7-13.6,11.8-13.6s11.9,5.4,11.9,13.6-4.8,13.6-11.9,13.6-11.8-5.4-11.8-13.6ZM206,218c0-5.4-2.3-8.6-6.1-8.6s-6.1,3.1-6.1,8.6,2.3,8.6,6.1,8.6,6.1-3.2,6.1-8.6Z"/></g></g></svg>`
                     $('.product__media-wrapper .discount-season-badge').html(badge)
                   }
              else{
              $('.product__media-wrapper .discount-season-badge').html('')
                $('.badge--bottom-left').css('display','inline-block')
                $('.badge--bottom-left').text('-'+ (100-parseInt(parseFloat(variant.price.replace('$ ','').replace(',',''))*100/parseFloat(variant.compare_at_price.replace('$ ','').replace(',',''))))+'%')
              }
            }
            else{
                $('.badge--bottom-left').css('display','none')
                $('.price-item.price-item--regular').text(price)
                $('.product .price').removeClass('price--on-sale')
                $('.price__sale').css('display','none')
                $('.price__regular').css('display','flex')
            }
            $('.availability.product-about__outer h2 span').css('font-weight','normal')
            if(sizes.length == 0){
              $('.product__media-list .badge--bottom-left').css('display','inline-block')
              $('.product__media-list .badge--bottom-left').text('AGOTADO')
              $('.availability.product-about__outer h2 span').css('font-weight','bold')
              if(!$('.availability.product-about__outer h2').hasClass('active')){
                $('.availability.product-about__outer h2').click()
              }
            }
        }
    }
}
function mp_update_sizes(){
    var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
    let sizes = []
    for(const variant of variantsInfo){
        if(variant.product == variantProductId){
            if(variant.available){
                sizes.push(variant.options[0])
            }
        }
    }
    let available = true
    $('#SingleOptionSelector-0 input').each(function(){
        if(sizes.includes($(this).val())){
            $(this).removeClass('disabled')
        }
        else{
            $(this).addClass('disabled')
            if(variantSize == $(this).attr('val')){
                available = false
            }
        }
    })
    console.log(available)
  console.log(sizes)
    if(!available){
      console.log('No está disponible')
        console.log($('.labellll *[val="'+variantSize+'"]'))
        $('*[val="'+variantSize+'"].pills-variant-labels').removeClass('round-border')
        $('.product-form__submit').attr('disabled','disabled')
        $('.product-form__submit').text('Agotado. Puedes buscar la disponibilidad de este producto en tienda física')
        currentVariant = null
    }
    else{
        $('*[val="'+variantSize+'"].pills-variant-labels').addClass('round-border')
        $('.product-form__submit').removeAttr('disabled')
        $('.product-form__submit').text('AGREGAR A MI BOLSA')
    }
}

function mp_add_to_cart(){
    const color = variantColor
    const size = variantSize
    const product = currentVariant

    let config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const cart = document.querySelector("cart-drawer")
    const formData = new FormData();
    formData.append('TALLA', size);
    formData.append('COLOR', color);
    formData.append('form_type', 'product'); 
    formData.append('id', product);
    //formData.append('properties', JSON.stringify({"color":color}));
    formData.append('quantity', $('.quantity__input').val());
    if (cart) {
        formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
        ncaddToken()
        uploadCart() 
        console.log(this)
        if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
        } else if (!cart) {
            window.location = window.routes.cart_url;
            return;
        }

        if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
            });
        this.error = false;
        const quickAddModal = document.querySelector("quick-add-modal");
        if (quickAddModal) {
            document.body.addEventListener(
                "modalClosed",
                () => {
                    setTimeout(() => {
                        cart.renderContents(response);
                    });
                },
                { once: true }
            );
            quickAddModal.hide(true);
        } else {
            cart.renderContents(response);
        }
    })
    .catch((e) => {
        console.error(e);
    })
}